import { useEffect, useState, useRef } from "react";
import Header from "../../../../components/ui/Header";
import FooterSection from "../../../../components/ui/Footer";

const TEMPLATES = [
  {
    id: "improved",
    name: "Two Column",
    description: "Modern two-column layout with skill pills",
    color: "#2E7D32",
    bg: "#e8f5e9",
    endpoint: "http://localhost:8000/download-improved-resume",
    preview: (
      <div style={{ background: "white", padding: "12px", borderRadius: "8px", fontSize: "7px", lineHeight: 1.4 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #eee", paddingBottom: "6px", marginBottom: "6px" }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: "10px", color: "#1a1a1a" }}>JOHN DOE</div>
            <div style={{ color: "#2E7D32", fontSize: "8px" }}>Software Engineer</div>
            <div style={{ color: "#888", fontSize: "6px" }}>john@email.com | linkedin.com/in/john</div>
          </div>
          <div style={{ width: "22px", height: "22px", borderRadius: "50%", background: "#1565C0", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: "7px", fontWeight: 700 }}>JD</div>
        </div>
        <div style={{ display: "flex", gap: "6px" }}>
          <div style={{ flex: 2 }}>
            <div style={{ fontWeight: 700, fontSize: "7px", marginBottom: "2px", color: "#333" }}>EXPERIENCE</div>
            <div style={{ height: "1px", background: "#ddd", marginBottom: "3px" }} />
            <div style={{ fontWeight: 600, fontSize: "6px" }}>Senior Developer</div>
            <div style={{ color: "#2E7D32", fontSize: "6px" }}>Tech Corp  2022-Present</div>
            <div style={{ color: "#666", fontSize: "5.5px", marginTop: "2px" }}>• Built scalable APIs handling 500K+ requests</div>
            <div style={{ color: "#666", fontSize: "5.5px" }}>• Reduced load time by 40% using caching</div>
            <div style={{ fontWeight: 700, fontSize: "7px", marginTop: "5px", marginBottom: "2px", color: "#333" }}>EDUCATION</div>
            <div style={{ height: "1px", background: "#ddd", marginBottom: "3px" }} />
            <div style={{ fontSize: "6px", color: "#555" }}>B.Tech Computer Science</div>
            <div style={{ fontSize: "5.5px", color: "#888" }}>State University • 2020</div>
          </div>
          <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "6px" }}>
            <div style={{ fontWeight: 700, fontSize: "7px", marginBottom: "2px", color: "#333" }}>SKILLS</div>
            <div style={{ height: "1px", background: "#ddd", marginBottom: "4px" }} />
            {["Python", "React", "SQL", "Docker", "AWS"].map((s, i) => (
              <span key={i} style={{ display: "inline-block", background: "#eee", color: "#333", borderRadius: "8px", padding: "1px 5px", fontSize: "5.5px", margin: "1px" }}>{s}</span>
            ))}
            <div style={{ fontWeight: 700, fontSize: "7px", marginTop: "5px", marginBottom: "2px", color: "#333" }}>PROJECTS</div>
            <div style={{ height: "1px", background: "#ddd", marginBottom: "3px" }} />
            <div style={{ fontWeight: 600, fontSize: "6px" }}>E-Commerce App</div>
            <div style={{ color: "#666", fontSize: "5.5px" }}>• Built with React & Node.js</div>
          </div>
        </div>
      </div>
    )
  },
  {
    id: "ats",
    name: "ATS Optimized",
    description: "Clean single-column, best for ATS systems",
    color: "#1565C0",
    bg: "#e3f2fd",
    endpoint: "http://localhost:8000/download-ats-resume",
    preview: (
      <div style={{ background: "white", padding: "12px", borderRadius: "8px", fontSize: "7px", lineHeight: 1.4 }}>
        <div style={{ textAlign: "center", borderBottom: "2px solid #000", paddingBottom: "6px", marginBottom: "6px" }}>
          <div style={{ fontWeight: 700, fontSize: "11px", color: "#000" }}>JOHN DOE</div>
          <div style={{ color: "#555", fontSize: "6.5px" }}>john@email.com | 9876543210 | linkedin.com/in/john | Chennai</div>
        </div>
        {[
          { title: "SUMMARY", lines: ["Results-driven engineer with 3+ years building scalable systems."] },
          { title: "TECHNICAL SKILLS", lines: ["Languages: Python, Java, JavaScript", "Tools: Docker, Git, AWS, PostgreSQL"] },
          { title: "EXPERIENCE", lines: ["Software Engineer — Tech Corp  (2022–Present)", "• Developed REST APIs serving 1M+ daily users", "• Improved DB query performance by 35%"] },
          { title: "EDUCATION", lines: ["B.Tech Computer Science — State University, 2020"] }
        ].map((sec, i) => (
          <div key={i} style={{ marginBottom: "5px" }}>
            <div style={{ fontWeight: 700, fontSize: "7px", borderBottom: "1px solid #000", marginBottom: "2px" }}>{sec.title}</div>
            {sec.lines.map((l, j) => <div key={j} style={{ color: "#444", fontSize: "6px" }}>{l}</div>)}
          </div>
        ))}
      </div>
    )
  },
  {
    id: "dark",
    name: "Dark Panel",
    description: "Professional dark sidebar design",
    color: "#1a2332",
    bg: "#e8eaf6",
    endpoint: "http://localhost:8000/download-dark-panel-resume",
    preview: (
      <div style={{ background: "white", borderRadius: "8px", overflow: "hidden", display: "flex", fontSize: "7px", lineHeight: 1.4 }}>
        <div style={{ background: "#1a2332", width: "38%", padding: "10px 8px", color: "white" }}>
          <div style={{ width: "30px", height: "30px", borderRadius: "50%", background: "#263340", border: "1.5px solid #4FC3F7", margin: "0 auto 6px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "6px", color: "#4FC3F7" }}>PHOTO</div>
          <div style={{ fontWeight: 700, fontSize: "8px", textAlign: "center", marginBottom: "2px" }}>JOHN DOE</div>
          <div style={{ color: "#4FC3F7", fontSize: "6px", textAlign: "center", marginBottom: "6px" }}>Data Engineer</div>
          <div style={{ color: "#4FC3F7", fontSize: "6px", fontWeight: 700, marginBottom: "3px" }}>CONTACT</div>
          <div style={{ color: "#B0BEC5", fontSize: "5.5px", marginBottom: "1px" }}>📞 9876543210</div>
          <div style={{ color: "#B0BEC5", fontSize: "5.5px", marginBottom: "1px" }}>✉ john@email.com</div>
          <div style={{ color: "#B0BEC5", fontSize: "5.5px", marginBottom: "6px" }}>📍 Chennai</div>
          <div style={{ color: "#4FC3F7", fontSize: "6px", fontWeight: 700, marginBottom: "3px" }}>SKILLS</div>
          {["Python", "SQL", "Spark", "Airflow", "AWS"].map((s, i) => (
            <div key={i} style={{ color: "white", fontSize: "5.5px", marginBottom: "1px" }}>• {s}</div>
          ))}
        </div>
        <div style={{ flex: 1, padding: "10px 8px" }}>
          <div style={{ fontWeight: 700, fontSize: "7px", borderBottom: "1px solid #eee", marginBottom: "3px", color: "#1a1a1a" }}>WORK EXPERIENCE</div>
          <div style={{ fontWeight: 600, fontSize: "6.5px" }}>Data Engineer</div>
          <div style={{ color: "#1565C0", fontSize: "6px" }}>Analytics Co  <span style={{ color: "#999" }}>2022–Present</span></div>
          <div style={{ color: "#555", fontSize: "5.5px", marginTop: "2px" }}>• Built ETL pipelines for 10M+ records</div>
          <div style={{ color: "#555", fontSize: "5.5px" }}>• Reduced processing time by 40%</div>
          <div style={{ fontWeight: 700, fontSize: "7px", borderBottom: "1px solid #eee", marginTop: "5px", marginBottom: "3px", color: "#1a1a1a" }}>PROJECTS</div>
          <div style={{ fontWeight: 600, fontSize: "6.5px" }}>Data Pipeline Automation</div>
          <div style={{ color: "#555", fontSize: "5.5px" }}>• Automated reporting saving 10hrs/week</div>
          <div style={{ fontWeight: 700, fontSize: "7px", borderBottom: "1px solid #eee", marginTop: "5px", marginBottom: "3px", color: "#1a1a1a" }}>EDUCATION</div>
          <div style={{ fontSize: "6px", color: "#444" }}>B.Tech CSE — State University, 2020</div>
        </div>
      </div>
    )
  },
  {
    id: "elegant",
    name: "Elegant Centered",
    description: "Elegant centered layout with crimson accents",
    color: "#C0392B",
    bg: "#fff0f0",
    endpoint: "http://localhost:8000/download-elegant-resume",
    preview: (
      <div style={{ background: "white", padding: "12px", borderRadius: "8px", fontSize: "7px", lineHeight: 1.4 }}>
        <div style={{ textAlign: "center", marginBottom: "6px" }}>
          <div style={{ width: "28px", height: "28px", borderRadius: "50%", border: "1.5px solid #C0392B", background: "#fff0f0", margin: "0 auto 4px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "5.5px", color: "#C0392B" }}>PHOTO</div>
          <div style={{ fontWeight: 700, fontSize: "12px", color: "#C0392B" }}>JOHN DOE</div>
          <div style={{ color: "#666", fontSize: "7px" }}>Product Manager</div>
          <div style={{ color: "#999", fontSize: "6px" }}>john@email.com  |  9876543210  |  Chennai</div>
        </div>
        <div style={{ borderTop: "1.5px solid #C0392B", borderBottom: "0.5px solid #f4b8b3", marginBottom: "5px" }} />
        {[
          { title: "Profile", lines: ["Strategic PM with 4+ years driving product growth and delivering user-centric solutions."] },
          { title: "Work Experience", lines: ["Product Manager — StartupXYZ (2021–Present)", "• Launched 3 features increasing retention by 25%"] },
          { title: "Skills", chips: ["Roadmap", "Agile", "KPI", "Jira", "A/B Testing", "OKR"] },
          { title: "Education", lines: ["MBA — Premier Business School, 2021"] }
        ].map((sec, i) => (
          <div key={i} style={{ marginBottom: "5px" }}>
            <div style={{ fontWeight: 700, fontSize: "7px", color: "#1a1a1a", borderBottom: "0.5px solid #f4b8b3", marginBottom: "2px" }}>{sec.title}</div>
            {sec.lines && sec.lines.map((l, j) => <div key={j} style={{ color: "#555", fontSize: "6px" }}>{l}</div>)}
            {sec.chips && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "2px", marginTop: "2px" }}>
                {sec.chips.map((c, j) => (
                  <span key={j} style={{ background: "#fff0f0", color: "#C0392B", border: "0.5px solid #f4b8b3", borderRadius: "4px", padding: "1px 4px", fontSize: "5.5px" }}>{c}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    )
  }
];

export default function ResumeFixed() {
  const [loading, setLoading] = useState(null);
  const [resumeFile, setResumeFile] = useState(null);
  const [jobRole, setJobRole] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    const role = localStorage.getItem("job_role_applied") || "";
    setJobRole(role);

    const analysis = JSON.parse(localStorage.getItem("resume_analysis_data")) || {};
    const missingSkills = analysis.fullReport?.missingKeywords || [];
    const savedJD = analysis.jobDescription || "";

    if (missingSkills.length > 0 && !savedJD) {
      setJobDescription(`Key required skills: ${missingSkills.join(", ")}`);
    } else {
      setJobDescription(savedJD);
    }
  }, []);

  const handleDownload = async (template) => {
    if (!resumeFile) {
      alert("Please upload your resume PDF first");
      fileInputRef.current?.click();
      return;
    }

    setLoading(template.id);

    try {
      const analysis = JSON.parse(localStorage.getItem("resume_analysis_data")) || {};
      const missingSkills = analysis.fullReport?.missingKeywords || [];

      const missingSkillsText = missingSkills.length > 0
        ? `\n\nRequired Skills for this role: ${missingSkills.join(", ")}`
        : "";

      const enrichedJobDescription = jobDescription + missingSkillsText;

      const formData = new FormData();
      formData.append("resume", resumeFile);
      formData.append("jobRole", jobRole);
      formData.append("jobDescription", enrichedJobDescription);
      formData.append("linkedinUrl", "");
      formData.append("githubUrl", "");

      const response = await fetch(template.endpoint, {
        method: "POST",
        body: formData
      });

      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `resume_${template.id}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error("Download error:", err);
      alert("Download failed. Make sure your backend is running.");
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />

      {/* ✅ FIX: max-w container is now properly open and wraps ALL content */}
      <main className="pt-20 pb-32">
        <div className="max-w-5xl mx-auto px-6">

          {/* HEADER */}
          <div className="text-center mb-10">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              🚀 AI Optimized Resume
            </h1>
            <p className="text-gray-500">
              Choose a template and download your AI-improved resume as PDF
            </p>
          </div>

          {/* UPLOAD RESUME */}
          <div
            style={{
              background: resumeFile ? "#e8f5e9" : "#fff8e1",
              border: `2px dashed ${resumeFile ? "#2e7d32" : "#f57f17"}`,
              borderRadius: "12px", padding: "20px",
              textAlign: "center", marginBottom: "32px", cursor: "pointer"
            }}
            onClick={() => fileInputRef.current?.click()}
          >
            <input
              type="file"
              accept=".pdf"
              hidden
              ref={fileInputRef}
              onChange={(e) => {
                if (e.target.files[0]) setResumeFile(e.target.files[0]);
              }}
            />
            {resumeFile ? (
              <p style={{ color: "#2e7d32", fontWeight: 600 }}>
                ✅ Resume uploaded: {resumeFile.name} — Click to change
              </p>
            ) : (
              <>
                <p style={{ color: "#f57f17", fontWeight: 600, marginBottom: 4 }}>
                  ⚠ Upload your resume PDF to generate templates
                </p>
                <p style={{ color: "#999", fontSize: "13px" }}>
                  Click here to upload your PDF resume
                </p>
              </>
            )}
          </div>

          {/* 4 TEMPLATE CARDS */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "20px",
            marginBottom: "32px"
          }}>
            {TEMPLATES.map((template) => (
              <div
                key={template.id}
                style={{
                  border: `2px solid ${template.color}20`,
                  borderRadius: "16px", overflow: "hidden",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                  background: "white",
                  transition: "transform 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.08)";
                }}
              >
                {/* PREVIEW BANNER */}
                <div style={{
                  background: template.bg,
                  padding: "16px",
                  borderBottom: `3px solid ${template.color}30`
                }}>
                  <div style={{
                    transform: "scale(0.85)", transformOrigin: "top center",
                    background: "white", borderRadius: "6px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                    overflow: "hidden"
                  }}>
                    {template.preview}
                  </div>
                </div>

                {/* CARD BODY */}
                <div style={{ padding: "14px" }}>
                  <div style={{
                    fontSize: "13px", fontWeight: 700,
                    color: template.color, textTransform: "uppercase",
                    letterSpacing: "0.5px", marginBottom: "4px"
                  }}>
                    {template.name}
                  </div>
                  <p style={{
                    fontSize: "12px", color: "#666",
                    marginBottom: "12px", minHeight: "32px"
                  }}>
                    {template.description}
                  </p>

                  <button
                    onClick={() => handleDownload(template)}
                    disabled={loading === template.id}
                    style={{
                      width: "100%", padding: "10px",
                      background: loading === template.id ? "#ccc" : template.color,
                      color: "white", border: "none",
                      borderRadius: "8px", fontWeight: 600,
                      fontSize: "14px", cursor: loading === template.id ? "not-allowed" : "pointer"
                    }}
                  >
                    {loading === template.id ? "⏳ Generating..." : "⬇ Download PDF"}
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* JOB ROLE + JD INPUTS */}
          <div style={{
            background: "#f8f9fa",
            borderRadius: "12px", padding: "20px"
          }}>
            <h3 style={{ margin: "0 0 12px", fontSize: "16px", color: "#333" }}>
              ⚙ Customize Resume Generation
            </h3>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <div style={{ flex: 1, minWidth: "200px" }}>
                <label style={{ fontSize: "13px", color: "#666", display: "block", marginBottom: "4px" }}>
                  Target Job Role
                </label>
                <input
                  value={jobRole}
                  onChange={e => setJobRole(e.target.value)}
                  placeholder="e.g. Data Engineer"
                  style={{
                    width: "100%", padding: "8px 12px",
                    border: "1px solid #ddd", borderRadius: "8px",
                    fontSize: "14px"
                  }}
                />
              </div>
              <div style={{ flex: 2, minWidth: "200px" }}>
                <label style={{ fontSize: "13px", color: "#666", display: "block", marginBottom: "4px" }}>
                  Job Description (optional)
                </label>
                <input
                  value={jobDescription}
                  onChange={e => setJobDescription(e.target.value)}
                  placeholder="Paste job description to tailor resume..."
                  style={{
                    width: "100%", padding: "8px 12px",
                    border: "1px solid #ddd", borderRadius: "8px",
                    fontSize: "14px"
                  }}
                />
              </div>
            </div>
          </div>

        </div>{/* ✅ closes max-w-5xl */}
      </main>

      <FooterSection />
    </div>
  );
}